import L from "leaflet";
import { useEffect } from "react";
import { useMap } from "react-leaflet";
import MapMarkerData from "../../../model/MapMarkerData";

function MapFitBounds({
  markers,
  mapRef,
  recordId,
  inputMarker,
}: {
  markers: { lat: number; lon: number }[];
  mapRef: React.MutableRefObject<L.Map | null>;
  recordId: number;
  inputMarker?: MapMarkerData;
}) {
  const map = useMap();

  useEffect(() => {
    if (map && markers.length > 0) {
      if (markers.length === 1) {
        const zoomLevel = recordId > 0 ? 6 : 15;
        map.setView([markers[0].lat, markers[0].lon], zoomLevel);
      } else {
        const bounds = L.latLngBounds(markers.map((m) => [m.lat, m.lon]));
        map.fitBounds(bounds, { padding: [50, 50] });
      }
    } else {
      if (inputMarker) {
        map.setView([inputMarker.lat, inputMarker.lon], 6);
      }
    }
  }, [markers, map, recordId]);

  return null;
}

export default MapFitBounds;
